import { createSlice } from "@reduxjs/toolkit";

const persistedUser = localStorage.getItem("userState");
const parsedUser = persistedUser ? JSON.parse(persistedUser) : {};
const userSlice = createSlice({
  name: "user",
  initialState: {
    user: parsedUser.user || null,
    loading: parsedUser.loading || false,
    isAuthenticated: parsedUser.isAuthenticated || null,
    error: parsedUser.error || " ",
    message: parsedUser.message || "",
  },
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.isAuthenticated = action.payload.accessToken;
      state.error = "";
      state.message = "Logged in successfully";
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setMessage(state, action) {
      state.message = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
      state.isAuthenticated = null;
    },
    logoutUser(state) {
      state.user = null;
      state.profile = null;
      state.loading = false;
      state.isAuthenticated = null;
      state.error = "";
      state.message = "Logged out successfully";
    },
    getDashboardLoading(state) {
      state.loading = true;
    },
    getDashboardSuccess(state, action) {
      state.profile = action.payload;
      state.loading = false;
    },
    getDashboardFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setUserTokenLoading(state) {
      state.loading = true;
    },
    setUserTokenSuccess(state, action) {
      state.user.accessToken = action.payload;
      state.isAuthenticated = action.payload;
      state.loading = false;
    },
    setUserTokenFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  setUser,
  setLoading,
  setError,
  setMessage,
  logoutUser,
  getDashboardLoading,
  getDashboardSuccess,
  getDashboardFail,
  setUserTokenLoading,
  setUserTokenSuccess,
  setUserTokenFail,
} = userSlice.actions;

export default userSlice.reducer;
